import React, { Component } from 'react';
import GitSearch from './GitSearch';

class App extends Component {
  render(){
    return (
      <div>
        <GitSearch />
      </div>
    );
  }
}

export default App;
